import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PasswordRegexHandler {

  passwordStrengthValidator(control: any) {
    if (!control.value) {
      return null;
    }

    const hasUpperCase = /[A-Z]/.test(control.value);
    const hasNumber = /[0-9]/.test(control.value);
    const hasSymbol = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(control.value);

    const valid = hasUpperCase && hasNumber && hasSymbol;

    return valid ? null : { weakPassword: true };
  }
  
}
